module.exports = __webpack_public_path__ + "h5/img/bs_18.4fd65ee3.jpeg";